// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();


export const loginWithEmailPassword = async( data:any ) => {
   
    try {
        
        return await http.postLogin<any>('/v1/login', data); 

    } catch (error) {
        console.log('tonkaaaaaaaaaaaaaaaaaa ',error)
    }
}